export const catalog = {
    title: 'Catálogo',
    products: 'Productos',
    categories: {
        title: 'Categorías',
        all: 'Todos',
        new: 'Drones Nuevos',
        used: 'Drones Usados',
        buffalo: 'Línea Buffalo',
        'power-citros': 'Power Citros',
        parts: 'Repuestos y Accesorios',
    },
    noProducts: 'No se encontraron productos',
    noCategories: 'No se encontraron categorías',
    viewProduct: 'Ver producto',
    addToCart: 'Añadir al carrito',
    productDetails: 'Detalles del producto',
    description: 'Descripción',
    specifications: 'Especificaciones',
    reviews: 'Reseñas',
    relatedProducts: 'Productos relacionados',
    searchPlaceholder: 'Buscar productos...',
    filterBy: 'Filtrar por',
    sortBy: 'Ordenar por',
    clearFilters: 'Limpiar Filtros',
    sortOptions: {
        priceAsc: 'Precio: menor a mayor',
        priceDesc: 'Precio: mayor a menor',
        nameAsc: 'Nombre: A-Z',
        nameDesc: 'Nombre: Z-A',
        newest: 'Más recientes',
        oldest: 'Más antiguos',
    },
    results: {
        showing: 'Mostrando',
        of: 'de',
        results: 'resultados',
    },
    pagination: {
        ariaLabel: 'Navegación de páginas',
        previous: 'Anterior',
        next: 'Siguiente',
        page: 'Página {{page}}',
    },
};
//# sourceMappingURL=catalog.js.map